module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-mini"
  }, [_c('div', {
    staticClass: "map-wrapper"
  }, [_c('div', {
    staticClass: "map-container",
    class: {
      show: _vm.mode == 'traffic'
    },
    attrs: {
      "id": "trafficMap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "map-container",
    class: {
      show: _vm.mode == 'weather'
    },
    attrs: {
      "id": "weatherMap"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f55c3cce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/map-mini.vue
// module id = 581
// module chunks = 0